import './animatedTitle.scss';

export default function AnimatedTitle() {
        
    return (
        <p className='animatedTitle'><span className='purple'>&lt;</span>Clément HUBERT <span className='purple'>/&gt;</span></p>
    )
}